import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTABar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollPosition > documentHeight * 0.3) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-248">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 md:bottom-auto md:top-0 z-40 bg-white/90 backdrop-blur-md shadow-[0_-4px_20px_rgba(0,0,0,0.05)] md:shadow-[0_4px_20px_rgba(0,0,0,0.05)] border-t md:border-t-0 md:border-b border-sage/20" data-id="element-249">
          <div className="max-w-layout mx-auto px-4 py-3 md:py-4 flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-250">
            <p className="font-heading font-semibold text-teal text-sm md:text-base text-center md:text-left" data-id="element-251">
              Recupera tu bienestar hoy &rarr;
            </p>
            <button onClick={scrollToCheckout} className="w-full md:w-auto bg-teal hover:bg-teal-light text-white font-medium py-2.5 px-6 rounded-full transition-all shadow-sm hover:scale-105 hover:shadow-md text-sm md:text-base" data-id="element-252">
              QUIERO MI SISTEMA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}